<div class="content-wrap">
  <section class="content">
    <h1>
      {{ "login.your-city-card" | translate }}
    </h1>
    <ng-content></ng-content>
  </section>
</div>
